import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepo = ProductRepositoryImpl.getInstance();

const useGetVariantColors = (variantId: string) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data: variantColors } = useQuery(
    {
      queryKey: ["variantColors", variantId, auth],
      queryFn: async () => {
        return await productRepo.getColorVariants([variantId], auth, apiUrl);
      },
      enabled: Boolean(auth) && Boolean(variantId),
    },
    queryClient,
  );

  return { isLoading, variantColors };
};

export { useGetVariantColors };
